import type { SVGProps } from "react";

export function CampgroundIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M13.176 3.434a1 1 0 1 1 1.648 1.133l-1.61 2.342L21.526 19H22a1 1 0 1 1 0 2h-4.634l-.044-.07l-4.492-6.487a1.01 1.01 0 0 0-1.66 0L6.678 20.93l-.044.07H2a1 1 0 0 1 0-2h.474l8.313-12.092l-1.611-2.342a1 1 0 0 1 1.648-1.133L12 5.144ZM12 16.757L14.938 21H9.062z"
      />
    </svg>
  );
}
